<template>
  <div v-if="exhibitInfo?.onDisplay" class="flex items-center gap-2">
    <div class="hidden">
      {{ exhibitInfo }}
    </div>
    <img
      v-if="exhibitInfo?.type === ExhibitionType.AUSSTELLER"
      class="articleExhibit inline-block"
      alt="Aussteller Info"
      src="https://cdn.expert.de/53/d6/3c/4013451a75c98791c284c0f24b8da8c883/exhibit.png"
    >
    <div v-else class="exhibition-flag rounded-full inline-block px-4 py-0.5" :class="styleClass">
      {{ exhibitInfo?.type }}
    </div>
    <BasicIcon
      v-if="withInfo && exhibitInfo?.description && exhibitInfo?.description.length > 0"
      class="info-icon"
      :name="'circle-info-light'"
      :data-tooltip="exhibitInfo?.description"
    />
  </div>
</template>

<script setup lang="ts">
import { type ExhibitionInfo, ExhibitionType } from "@expert/types";

interface Props {
  exhibitInfo: ExhibitionInfo;
  withInfo?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  withInfo: false,
});

const styleClass = computed(() => {
  switch(props.exhibitInfo?.type) {
    case ExhibitionType.EXHIBITOR:
      return 'exhibitor';
    case ExhibitionType.DEMONSTRATION:
      return 'demonstration';
    case ExhibitionType.B_STOCK:
      return 'b-stock';
    case ExhibitionType.RETURNER:
      return 'returner';
    case ExhibitionType.ODDMENT:
      return 'oddment';
    default:
        return '';
  }
});
</script>

<style lang="postcss" scoped>
.exhibition-flag {
  @apply text-xs;
  color: rgb(var(--color-primary-contrast));
  font-style: normal;
  text-transform: none;
}

.exhibitor {
  background-color: #234F9D;
}

.demonstration {
  background-color: #94C01F;
}

[data-contrast="high"] .demonstration {
  @apply bg-success;
}

.b-stock {
  background-color: #E5232D;
}

[data-contrast="high"] .b-stock {
  @apply bg-primary;
}

.returner {
  background-color: #52AC38;
}

[data-contrast="high"] .returner {
  @apply bg-success;
}

.oddment {
  background-color: #EE7200;
}

[data-contrast="high"] .oddment {
  @apply bg-primary;
}


[data-tooltip]::after {
  background-color: #ebebeb;
  color: rgb(var(--paragraph));
  width: 250px;
  font-family: Lato, sans-serif;
  padding: 10px 20px;
  font-size: 14px;
  font-style: normal;
  text-align: left;
  z-index: 20;
}

[data-tooltip].tooltip-top::after {
  transform: translate(-50%, -105%);
}

[data-tooltip]:hover::before {
  visibility: hidden;
}

.info-icon {
  @apply ic-icon tooltip-top align-text-bottom text-paragraph-light inline-block;
  color: #FF5E19;
}
</style>